import { createContext, useEffect, useState } from "react";

export const appContext = createContext()

export default function AppProvider(props){
    const [token, setToken] = useState(null)
    const [notification, setNotification] = useState({})

    useEffect(() => {
        let _token = localStorage.getItem('mellaadmintoken')
        setToken(_token)
    }, [])
    
    return (
        <appContext.Provider value={{token, setToken, notification, setNotification}}>
            {props.children}
        </appContext.Provider>
    )
}